const mutations = {
  appendInformations: (state, payload) => {
    state.informations = payload;
  },
};

export { mutations };
